module.exports = __webpack_public_path__ + "img/entrepreneurship-455.7d1e233b.png";